import { clearCart } from "./shoppingCartSlice";
import { clearCheckoutTotem } from "./checkoutSlice";
import { clearProductSelection } from "./productsSlice";

// Deixa o aparelho de autoatendimento pronto para o próximo cliente: sacola,
// respostas do checkout e grupo/busca selecionados.
export const resetSelfcheckoutSession = () => (dispatch) => {
  dispatch(clearCart());
  dispatch(clearCheckoutTotem());
  dispatch(clearProductSelection());
};
